import { computed, get, set } from '@ember/object';

export default function integerToString(attribute: string) {
  return computed(attribute, {
    get() {
      return get(this, attribute)?.toString() ?? '';
    },

    set(_key: string, value: string) {
      set(this, attribute, parseInt(value));

      return value;
    },
  });
}
